import { defineStore } from "pinia";
import {
  getMyNotifications,
  getUnreadCount,
  markAsRead,
} from "@/modules/notifications/api/notification.service";

export const useNotificationStore = defineStore("notification", {
  state: () => ({
    notifications: [],
    unreadCount: 0,
    loading: false,
  }),

  actions: {
    async fetchNotifications(skip = 0, take = 50) {
      this.loading = true;
      try {
        const notifications = await getMyNotifications(skip, take);

        this.notifications = notifications.map((n) => ({
          id: n.id,
          targetType: n.targetType,
          targetId: n.targetId,
          title: n.title,
          message: n.message,
          createdAt: n.createdAt,
          isRead: n.isRead,
          orderId: n.orderId,
          isOrderAssigned: n.isOrderAssigned || false,
        }));

        this.unreadCount = this.notifications.filter((n) => !n.isRead).length;
      } catch (error) {
        console.error("Ошибка загрузки уведомлений:", error);
      } finally {
        this.loading = false;
      }
    },

    async fetchUnreadCount() {
      try {
        this.unreadCount = await getUnreadCount();
      } catch (error) {
        console.error("Ошибка загрузки unread count:", error);
      }
    },

    async markAsRead(notificationId) {
      try {
        await markAsRead(notificationId);

        const notification = this.notifications.find(
          (n) => n.id === notificationId,
        );
        if (notification && !notification.isRead) {
          notification.isRead = true;
          this.unreadCount = Math.max(0, this.unreadCount - 1);
        }
      } catch (error) {
        console.error("Ошибка при отметке прочитанного:", error);
        throw error;
      }
    },

    async markAllAsRead() {
      const unreadIds = this.notifications
        .filter((n) => !n.isRead)
        .map((n) => n.id);

      for (const id of unreadIds) {
        await this.markAsRead(id);
      }

      await this.fetchNotifications();
    },
  },
});
